import Marquee from "react-fast-marquee";

const words = [
  "Craft Cocktails",
  "Weddings",
  "Private Events",
  "Corporate",
  "Signature Menus",
  "Mixology",
  "Rooftop Soirées",
  "Bespoke Bars",
];

export default function MarqueeStrip() {
  return (
    <section className="py-6 border-y border-[#222] bg-[#0a0a0a]" data-testid="marquee-section">
      <Marquee speed={45} gradient={false} autoFill>
        {words.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-heading italic text-2xl md:text-4xl text-white/85 px-8">{w}</span>
            <span className="text-gold text-xl">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
